import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

export function useArrowsAiCsvImport() {
  const { t } = useI18n();

  const reasonLabel = reason => {
    switch (reason) {
      case 'missing_file':
        return t('ARROWS_AI.CSV.REASONS.MISSING_FILE');
      case 'empty_file':
        return t('ARROWS_AI.CSV.REASONS.EMPTY_FILE');
      case 'invalid_headers':
        return t('ARROWS_AI.CSV.REASONS.INVALID_HEADERS');
      case 'invalid_type':
        return t('ARROWS_AI.CSV.REASONS.INVALID_TYPE');
      case 'too_large':
        return t('ARROWS_AI.CSV.REASONS.TOO_LARGE');
      case 'too_many_rows':
        return t('ARROWS_AI.CSV.REASONS.TOO_MANY_ROWS');
      case 'malformed_csv':
        return t('ARROWS_AI.CSV.REASONS.MALFORMED_CSV');
      case 'question_blank':
        return t('ARROWS_AI.CSV.REASONS.QUESTION_BLANK');
      case 'answer_blank':
        return t('ARROWS_AI.CSV.REASONS.ANSWER_BLANK');
      case 'question_too_long':
        return t('ARROWS_AI.CSV.REASONS.QUESTION_TOO_LONG');
      case 'answer_too_long':
        return t('ARROWS_AI.CSV.REASONS.ANSWER_TOO_LONG');
      case 'name_blank':
        return t('ARROWS_AI.CSV.REASONS.NAME_BLANK');
      case 'name_too_long':
        return t('ARROWS_AI.CSV.REASONS.NAME_TOO_LONG');
      case 'description_too_long':
        return t('ARROWS_AI.CSV.REASONS.DESCRIPTION_TOO_LONG');
      case 'price_too_long':
        return t('ARROWS_AI.CSV.REASONS.PRICE_TOO_LONG');
      case 'duration_too_long':
        return t('ARROWS_AI.CSV.REASONS.DURATION_TOO_LONG');
      case 'duplicate':
        return t('ARROWS_AI.CSV.REASONS.DUPLICATE');
      case 'limit_reached':
        return t('ARROWS_AI.CSV.REASONS.LIMIT_REACHED');
      case 'invalid_row':
        return t('ARROWS_AI.CSV.REASONS.INVALID_ROW');
      default:
        return t('ARROWS_AI.CSV.INVALID_FILE');
    }
  };

  const notifyResult = data => {
    const failed = Array.isArray(data.failed) ? data.failed : [];
    useAlert(
      t('ARROWS_AI.CSV.SUCCESS', {
        imported: Array.isArray(data.imported) ? data.imported.length : 0,
        skipped: data.skipped || 0,
        failed: failed.length,
      })
    );
    if (!failed.length) return;

    useAlert(
      t('ARROWS_AI.CSV.FAILED_ROW', {
        row: failed[0].row,
        reason: reasonLabel(failed[0].reason),
      })
    );
  };

  const notifyError = error => {
    const reason = error?.response?.data?.reason;
    useAlert(reason ? reasonLabel(reason) : t('ARROWS_AI.CSV.INVALID_FILE'));
  };

  return { notifyResult, notifyError };
}
